<div class="api-key-scopes-container">
  <!-- Header -->
  <div class="section-header">
    <div class="header-content">
      <h2>API Key Scopes</h2>
      <p class="section-description" *ngIf="apiKey">
        Manage permissions for: <strong>{{ apiKey.Label }}</strong>
      </p>
      <p class="section-description" *ngIf="!apiKey && !apiKeyId">
        Select scopes to assign
      </p>
    </div>
    <div class="header-actions" *ngIf="!apiKeyId">
      <button class="btn btn-secondary btn-sm" (click)="selectAll()">Select All</button>
      <button class="btn btn-secondary btn-sm" (click)="deselectAll()">Deselect All</button>
    </div>
  </div>

  <!-- Messages -->
  <div class="message error-message" *ngIf="errorMessage">
    <i class="fas fa-exclamation-circle"></i> {{ errorMessage }}
  </div>
  <div class="message success-message" *ngIf="successMessage">
    <i class="fas fa-check-circle"></i> {{ successMessage }}
  </div>

  <!-- Loading State -->
  <div class="loading-container" *ngIf="isLoading">
    <i class="fas fa-spinner fa-spin"></i> Loading scopes...
  </div>

  <!-- Search and Stats -->
  <div class="filters-row" *ngIf="!isLoading">
    <div class="search-box">
      <i class="fas fa-search"></i>
      <input type="text" [(ngModel)]="searchQuery" placeholder="Search scopes..." />
    </div>
    <div class="selection-stats">
      <span class="stat-badge">
        <i class="fas fa-check-circle"></i>
        {{ selectedCount }} of {{ allScopes.length }} selected
      </span>
    </div>
  </div>

  <!-- Scopes Checklist -->
  <div class="scopes-checklist card" *ngIf="!isLoading">
    <div class="scope-item" *ngFor="let ss of filteredSelections"
         [class.selected]="ss.isSelected"
         (click)="toggleScope(ss)">
      <div class="checkbox">
        <i class="fas" [ngClass]="ss.isSelected ? 'fa-check-square' : 'fa-square'"></i>
      </div>
      <div class="scope-icon">
        <i class="fas" [ngClass]="getScopeIcon(ss.scope.Name)"></i>
      </div>
      <div class="scope-info">
        <span class="scope-name">{{ ss.scope.Name }}</span>
        <span class="scope-description">{{ ss.scope.Description || 'No description' }}</span>
      </div>
      <div class="saving-indicator" *ngIf="isSaving">
        <i class="fas fa-spinner fa-spin"></i>
      </div>
    </div>

    <!-- Empty State -->
    <div class="empty-state" *ngIf="filteredSelections.length === 0">
      <i class="fas fa-shield-alt"></i>
      <p *ngIf="searchQuery">No scopes match your search</p>
      <p *ngIf="!searchQuery">No scopes available</p>
    </div>
  </div>

  <!-- Selected Scopes Summary (for standalone use) -->
  <div class="selected-summary" *ngIf="!isLoading && !apiKeyId && selectedCount > 0">
    <h4>Selected Scopes:</h4>
    <div class="selected-tags">
      <span class="scope-tag" *ngFor="let ss of scopeSelections | keyvalue">
        <ng-container *ngIf="ss.value.isSelected">
          {{ ss.value.scope.Name }}
          <button class="remove-tag" (click)="toggleScope(ss.value); $event.stopPropagation()">
            <i class="fas fa-times"></i>
          </button>
        </ng-container>
      </span>
    </div>
  </div>
</div>
